module.exports = __webpack_public_path__ + "static/media/vi.24789c93.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/vi.svg
// module id = 2241
// module chunks = 0